import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { styled } from 'themes';
import TrustPilotBadge from 'components/trust-pilot-badge';
import { device } from 'themes/media-queries';
import { useTranslation } from 'react-i18next';

const TrustPilotTestimonials = () => {
  const { t } = useTranslation();
  const data = useStaticQuery(graphql`
    query TrustPilotTestimonialsQuery {
      mockImage: imageSharp(
        fluid: { originalName: { regex: "/mock-category-selector/" } }
      ) {
        fluid(maxWidth: 1080, quality: 90) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  `);
  return (
    <Section>
      <ImageContainer>
        <Img fluid={data.mockImage.fluid} />
      </ImageContainer>
      <Citation>
        <Line />
        <Quote>
          <p>{t('trustpilot.quote')}</p>
          <footer>
            <strong>{t('trustpilot.name')}</strong>
            <span>{t('trustpilot.age')}</span>
          </footer>
        </Quote>
      </Citation>
      <BadgeWrapper>
        <TrustPilotBadge />
      </BadgeWrapper>
    </Section>
  );
};

const Section = styled.section`
  position: relative;
  grid-column: center-start / center-end;
  display: flex;
  margin-top: -15rem;

  @media ${device.laptopL} {
    margin-top: -5rem;
  }

  @media ${device.laptop} {
    grid-column: full-start / center-end;
    margin-top: 0;
  }

  @media ${device.mobileL} {
    flex-direction: column;
  }
`;

const Line = styled.hr`
  background-color: ${props => props.theme.colors.greenish};
  border: 1px solid ${props => props.theme.colors.greenish};
  width: 100px;
  margin: 0 15px 0 0;
`;

const ImageContainer = styled.div`
  width: 30rem;

  @media ${device.laptop} {
    display: none;
  }
`;

const Citation = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1rem;

  @media ${device.mobileM} {
    margin-bottom: 2rem;
  }
`;

const Quote = styled.blockquote`
  max-width: 60rem;
  & > p {
    font-size: 3.2rem;
    font-family: 'Playfair Display';

    @media ${device.tablet} {
      font-size: 3rem;
    }

    @media ${device.mobileL} {
      font-size: 2.2rem;
    }
  }

  & > footer {
    font-size: 1.3rem;
    color: ${props => props.theme.colors.battleshipGrey};
  }
`;

const BadgeWrapper = styled.div`
  align-self: flex-end;
`;

export default TrustPilotTestimonials;
